import TerminationActionTypes from './termination.types';

export const getTermDataFailure = (error) => ({
  type: TerminationActionTypes.GET_TERM_DATA_FAILURE,
  payload: error,
});

export const getTermDataSuccess = (data) => ({
  type: TerminationActionTypes.GET_TERM_DATA_SUCCESS,
  payload: data,
});

export const getTermDataStart = () => ({
  type: TerminationActionTypes.GET_TERM_DATA_START,
});

export const setTermDepartment = (department) => ({
  type: TerminationActionTypes.SET_TERM_DEPARTMENT,
  payload: department,
});

export const setTermPosition = (position) => ({
  type: TerminationActionTypes.SET_TERM_POSITION,
  payload: position,
});

export const setForwardingEmail = (email) => ({
  type: TerminationActionTypes.SET_FORWARDING_EMAIL,
  payload: email,
});

export const setTermNoc = (nocObj) => ({
  type: TerminationActionTypes.SET_TERM_NOC,
  payload: nocObj,
});

export const setTermNavitaire = (navitaireObj) => ({
  type: TerminationActionTypes.SET_TERM_NAVITAIRE,
  payload: navitaireObj,
});

export const setTermEmail = (email) => ({
  type: TerminationActionTypes.SET_TERM_EMAIL,
  payload: email,
});

export const setTermLocation = (location) => ({
  type: TerminationActionTypes.SET_TERM_LOCATION,
  payload: location,
});

export const setTermUber = (uberObj) => ({
  type: TerminationActionTypes.SET_TERM_UBER,
  payload: uberObj,
});

export const setTermLyft = (lyftObj) => ({
  type: TerminationActionTypes.SET_TERM_LYFT,
  payload: lyftObj,
});

export const setSuspendAzure = (suspend) => ({
  type: TerminationActionTypes.SET_SUSPEND_AZURE,
  payload: suspend,
});
